import { createContext } from 'react'
import { TSuppressionList } from './types'

export const SuppressionListContext = createContext<TSuppressionList>({

})